import { fetchSingleProduct } from '@app/services/productsRepository';
import { isDefined } from '@app/utils/is';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { Id } from '@typings';

export const PRODUCT_QUERY_KEY = 'PRODUCT_QUERY_KEY';

export const useProduct = (productId: string | undefined, deliveryWindows: Id[], buyerId: string | undefined) => {
  const isEnabled = isDefined(productId);

  return useQuery({
    ...getProductQuery(productId ?? '', deliveryWindows, buyerId ?? ''),
    enabled: isEnabled,
    refetchOnMount: false,
  });
};

export const getProductQuery = (productId: string, deliveryWindows: Id[], buyerId: string) =>
  queryOptions({
    queryFn: async () => fetchSingleProduct(productId, deliveryWindows, buyerId),
    queryKey: [PRODUCT_QUERY_KEY, productId, { buyerId, deliveryWindows }],
    staleTime: 60000,
  });
